import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';

@Component({
  selector: 'app-smart-tire-main',
  templateUrl: './smart-tire-main.component.html',
  styleUrl: './smart-tire-main.component.scss',
  standalone: false
})
export class SmartTireMainComponent {
  currentComponent: string;
  isMobile: any;
  private destroy$ = new Subject<void>();
  constructor(
    private smartireService: SmartTireService,
    private cdr: ChangeDetectorRef,
    private BreakpointObserver: BreakpointObserver
  ) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.isMobile = result.matches;
      });
  }
  ngOnInit() {
    this.smartireService.currentComponent$.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'visitorInfo';
      }
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
